import api from "../axios";

export const MainSubCategoryListingFunc = () => {
  const data = api.get("/mainsubcategory/getAllListing");
  return data;
};

export const ValidateOnlyMainCategoryFunc = ({ mainCategory }) => {
  const res = api.get("/maincategory/onlyvalidation", {
    params: {
      main_category: mainCategory,
    },
  });

  return res;
};

export const GetAllMainCategoriesFunc = () => {
  const res = api.get("/maincategory/getAllMainCategories");

  return res;
};

export const GetSomeMainCategoriesFunc = () => {
  const res = api.get("/maincategory/getSomeMainCategories");

  return res;
};

export const GetRelatedSubCategoryAgainstMainCategory = ({ mainCategory }) => {
  const res = api.get("/maincategory/getRelatedSubCategories", {
    params: {
      main_category: mainCategory,
    },
  });

  return res;
};
